export default "__VITE_ASSET__t99WDdMV__"